export const selectResult = (state) => state.result.toJS();
